<template>
  <div class="lp">
    <f-header-lp-top />
    <main class="main">
      <nuxt />
    </main>
    <f-footer-lp-top />
  </div>
</template>

<script>
  import {
    FFooterLpTop,
    FHeaderLpTop,
  } from '~/components/frontend';
  import cloudfrontMixin from "~/mixins/cloudfrontMixin";

  export default {
    name: 'frontend-layout',
    head() {
      return {
        meta: [
          {charset: 'utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {hid: 'description', name: 'description', content: ''}
        ],
        link: [
          {rel: 'stylesheet', type: 'text/css', href: '/frontend/css/style.css'},
        ]
      }
    },
    components: {
      FFooterLpTop,
      FHeaderLpTop
    },
    mixins: [cloudfrontMixin]
  }
</script>
